import 'reflect-metadata';
import { jsonObject, jsonMember, toJson } from 'typedjson';

@jsonObject
@toJson
export class AlbumCreateRequest {
  @jsonMember public name!: string;
  @jsonMember public projectId!: string;
  @jsonMember public cameraId!: string;
  @jsonMember public photoId!: string;
}

// eslint-disable-next-line max-classes-per-file
@jsonObject
export class AlbumUpdateRequest extends AlbumCreateRequest {
  @jsonMember public id!: string;
}

// eslint-disable-next-line max-classes-per-file
@jsonObject
@toJson
export class AlbumDeleteRequest {
  @jsonMember public id!: string;
}
